module.exports = __webpack_public_path__ + "media/images/touch/app-icon-4240c94b9d1aa6027b45668f597ea4b7.png";